import { m } from "framer-motion";
import { Star } from "lucide-react";

const ReviewWidget = () => {
  return (
    <section className="section-padding section-gradient-soft">
      <div className="container-max">
        <div className="text-center mb-10 md:mb-12">
          <m.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Customer Reviews
          </m.span>
          <m.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            What Our <span className="text-gradient-primary">Clients</span> Say
          </m.h2>
          <m.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex items-center justify-center gap-1 mb-3"
          >
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-secondary text-secondary" />
            ))}
          </m.div>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">
            Real reviews from homeowners across the DFW metroplex.
          </p>
        </div>

        <div className="relative">
          <iframe
            src="https://embed.gmbwidget.com/review-widget/w/rw_4d6ca48c4c09e959f605ef68"
            title="Customer reviews"
            width="100%"
            height="480"
            style={{ border: "none", display: "block", maxWidth: "100%" }}
            loading="lazy"
          />
          {/* Covers the drop shadow the widget renders inside its transparent
              iframe just below its card. The card bottom sits at ~80% (mobile),
              ~61% (tablet) and ~59% (desktop) of the 480px embed height, so the
              patch starts there with a soft fade and blends into the section
              background — the widget itself is never cropped or overlapped. */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-x-0 bottom-0 top-[79.8%] sm:top-[59.6%] lg:top-[58.2%]"
            style={{
              background:
                "linear-gradient(180deg, rgba(246,243,242,0) 0%, rgba(246,243,242,1) 6px)",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ReviewWidget;
